const React = require('react')
const { forwardRef, useImperativeHandle } = require('react')
const { useHistory } = require('react-router-dom')
const PropTypes = require('prop-types')
const { Button, Row, Col } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')

require('@styles/components/tabs.css')

const Tabs = forwardRef((props, ref) => {
    const history = useHistory()

    const { network } = useNetworkConfig()

    const activeTab = props.activeTab || 'overview'

    const handleTabChange = tab => {
        const currentQuery = window.location.search
        if (tab === 'overview' || tab === 'transactions' || tab === 'transfers') {
            history.push(`${currentQuery}#`)
        } else {
            history.push(`${currentQuery}#${tab}`)
        }
        if (props.onTabChange) {
            props.onTabChange(tab)
        }
    }

    useImperativeHandle(ref, () => ({
        handleTabChange
    }))

    return (
        <div className='tabs'>
            <Row className='flex-nowrap' style={{ overflowX: 'auto' }}>
                {props.items.map(item => (
                    <Col key={item.tab} style={{ minWidth: 'fit-content', paddingRight: '0px' }}>
                        <Button
                            className={`tab ${network.name}-tab-button ${activeTab === `${item.tab}` ? 'active' : ''}`}
                            style={{ whiteSpace: 'nowrap' }}
                            onClick={() => handleTabChange(`${item.tab}`)}
                        >
                            {item.text}
                            {item.tick && (
                                <span className='tab-circle'>
                                    <i className='fas fa-check' />
                                </span>
                            )}
                        </Button>
                    </Col>
                ))}
            </Row>
        </div>
    )
})

Tabs.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            tab: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired
        })
    ).isRequired,
    onTabChange: PropTypes.func,
    activeTab: PropTypes.string
}

module.exports = { Tabs }
